export default "__VITE_ASSET__1_zBoPPQ__"